var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{ name: _vm.linkTarget, params: _vm.getLinkParams() }}},[_vm._v("\n    "+_vm._s(_vm.lemma)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }